import { useEffect, useState } from "react";

/**
 * Отслеживает изменение активности вкладки браузера.
 */
export const useBrowserTabVisibility = () => {
  const [isBrowserTabVisible, setIsBrowserTabVisible] = useState(true);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsBrowserTabVisible(!document.hidden);
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return { isBrowserTabVisible };
};
